import React from 'react'

type OroSize = 'xs' | 'sm' | 'md' | 'lg'

interface OroProps {
  size?: OroSize
  /**
   * If true, show the subtle breathing animation.
   * You can disable it in some contexts (e.g., lists).
   */
  animated?: boolean
  /**
   * Optional center content (e.g., initials, tiny icon).
   */
  children?: React.ReactNode
  className?: string
}

const sizeClasses: Record<OroSize, string> = {
  xs: 'h-6 w-6',
  sm: 'h-8 w-8',
  md: 'h-10 w-10',
  lg: 'h-14 w-14',
}

export const Oro: React.FC<OroProps> = ({
  size = 'md',
  animated = true,
  children,
  className,
}) => {
  const clsx = (...classes: (string | undefined | false)[]): string => {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <div
      className={clsx(
        'relative inline-flex items-center justify-center',
        sizeClasses[size],
        className
      )}
    >
      {/* Outer breathing halo */}
      <div
        className={clsx(
          'absolute inset-0 rounded-full border border-oro-gold/18',
          animated && 'animate-oro-pulse'
        )}
      />

      {/* Glow layer */}
      <div
        className={clsx(
          'absolute inset-[12%] rounded-full border border-oro-gold/45 bg-oro-gold/6',
          animated && 'animate-oro-glow'
        )}
      />

      {/* Core ring */}
      <div className="absolute inset-[26%] rounded-full border border-oro-gold bg-oro-bg" />

      {/* Inner fill + content */}
      <div className="relative flex h-[42%] w-[42%] items-center justify-center rounded-full bg-oro-gold text-[9px] font-semibold text-oro-bg">
        {children ?? 'O'}
      </div>
    </div>
  )
}